export { default, getStaticPaths, getStaticProps } from "@src/apps/Standard";
